import StorageService from "./StorageService";
import {
    getSpaConfigBase as fetchSpaConfigBase,
    getSpaConfigFunctionApp as fetchSpaConfigFunctionApp,
    getSpaConfigKeyVault as fetchSpaConfigKeyVault,
    getSpaConfigMeetingPortal as fetchSpaConfigMeetingPortal
} from "./config";
import {SpaConfigBase, SpaConfigHttpResponse, SpaConfigKeyVault, SpaConfigMeetingPortal} from "./models/SpaConfig";

export enum SessionStorageKey {
    SpaConfigBase = 'spaConfigBase',
    SpaConfigHttpResponse = 'spaConfigHttpResponse',
    SpaConfigMeetingPortal = 'spaConfigMeetingPortal',
    SpaConfigKeyVault = 'spaConfigKeyVault',
}

export interface SessionStorageModel {
    [SessionStorageKey.SpaConfigBase]: SpaConfigBase
    [SessionStorageKey.SpaConfigHttpResponse]?: SpaConfigHttpResponse
    [SessionStorageKey.SpaConfigMeetingPortal]?: SpaConfigMeetingPortal
    [SessionStorageKey.SpaConfigKeyVault]?: SpaConfigKeyVault
}

export const sessionStorageService = new StorageService<SessionStorageModel>(
    window.sessionStorage
);

export const getSpaConfigBase = () =>
    sessionStorageService.get(SessionStorageKey.SpaConfigBase)!;

export const getSpaConfigHttpResponse = () =>
    sessionStorageService.get(SessionStorageKey.SpaConfigHttpResponse)!;

export const getSpaConfigMeetingPortal = () =>
    sessionStorageService.get(SessionStorageKey.SpaConfigMeetingPortal)!;

export const getSpaConfigKeyVault = () =>
    sessionStorageService.get(SessionStorageKey.SpaConfigKeyVault)!;

export const fetchSpaConfigBaseAndUpdateSessionStorage = async () => {
    const response = await fetchSpaConfigBase();
    sessionStorageService.set(SessionStorageKey.SpaConfigBase, response);
    return response;
}

export const fetchSpaConfigTriggerResponseAndUpdateSessionStorage = async () => {
    const response = await fetchSpaConfigFunctionApp();
    sessionStorageService.set(SessionStorageKey.SpaConfigHttpResponse, response);
    return response;
}

export const fetchSpaConfigMeetingPortalAndUpdateSessionStorage = async () => {
    const response = await fetchSpaConfigMeetingPortal();
    sessionStorageService.set(SessionStorageKey.SpaConfigMeetingPortal, response);
    return response;
}

export const fetchSpaConfigKeyVaultAndUpdateSessionStorage = async () => {
    const response = await fetchSpaConfigKeyVault();
    sessionStorageService.set(SessionStorageKey.SpaConfigKeyVault, response);
    return response;
}

const storageHelper = {
    getSpaConfigBase,
    getSpaConfigHttpResponse,
    getSpaConfigMeetingPortal,
    getSpaConfigKeyVault,
    fetchSpaConfigBaseAndUpdateSessionStorage,
    fetchSpaConfigTriggerResponseAndUpdateSessionStorage,
    fetchSpaConfigMeetingPortalAndUpdateSessionStorage,
    fetchSpaConfigKeyVaultAndUpdateSessionStorage
}

export default storageHelper;